<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading || archiveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
                <h2 class="tw-capitalize tw-text-secondary">
                    {{ mode }} event
                </h2>
                <v-form name="editForm" ref="editForm">
                    <div class="tw-flex tw-w-full tw-gap-4 tw-mb-2 tw-p-2">

                        <div class="tw-w-full tw-h-full" >
                            <w-y-s-i-w-y-g
                                v-if="activeEditor1"
                                v-model="modelObject.content"
                                :error-messages="errors?.content"
                                style="height: 350px !important;"
                                element_id="rte1"
                                id="rte1"
                                tabindex="0"
                            />
                        </div>

                        <div class="tw-flex tw-flex-col tw-gap-3">
                            <v-text-field tabindex="1"
                                v-model="modelObject.title"
                                label="Title"
                                :rules="[rules.required]"
                                clearable
                                hide-details="auto"
                                :error-messages="errors?.title"
                            ></v-text-field>

                            <date-picker tabindex="2"
                                v-model="modelObject.date"
                                dense
                                hide-details="auto"
                                color="primary"
                                display-label="Date"
                                :rules="[rules.required]"
                                reactive
                                ref="datePicker"
                                :error-messages="errors?.date"
                            />
                            <date-picker tabindex="3"
                                v-model="modelObject.date_end"
                                dense
                                hide-details="auto"
                                color="primary"
                                display-label="End date"
                                :rules="[]"
                                reactive
                                ref="datePicker2"
                                :error-messages="errors?.date_end"
                            />

                            <v-select tabindex="4"
                                v-model="modelObject.target"
                                :items="targetsValueList"
                                color="primary"
                                label="Target"
                                display-label="Target"
                                :rules="[rules.required]"
                                reactive
                                :error-messages="errors?.target"
                                hide-details="auto"
                            />

                            <v-text-field tabindex="5"
                                v-model="modelObject.image"
                                label="Current image"
                                clearable
                                v-show="false"
                                hide-details="auto"
                            ></v-text-field>

                            <v-file-input tabindex="6"
                                v-model="modelObject.new_image"
                                label="Image"
                                dense
                                outlined
                                :prepend-icon="null"
                                :rules="!is_edit_mode ? [rules.required] : []"
                                :error-messages="errors?.new_image"
                                hide-details="auto"
                            >
                            </v-file-input>

                            <v-select tabindex="7"
                                v-model="modelObject.image_color"
                                :items="photoFiltersValueList"
                                dense
                                color="primary"
                                label="Photo filter"
                                :rules="[rules.required]"
                                reactive
                                outlined
                                hide-details="auto"
                                :error-messages="errors?.image_color"
                            />

                            <v-select tabindex="8"
                                v-model="modelObject.awards_festivals"
                                :items="awardsValueList"
                                dense
                                color="primary"
                                label="Awards & Festivals"
                                clearable
                                reactive
                                outlined
                                hide-details="auto"
                                :error-messages="errors?.awards_festivals"
                            />

                            <v-select tabindex="9"
                                v-model="modelObject.outreach"
                                :items="outreachsValueList"
                                dense
                                color="primary"
                                label="Outreach"
                                clearable
                                reactive
                                outlined
                                hide-details="auto"
                                :error-messages="errors?.outreach"
                            />

                            <v-select tabindex="10"
                                v-model="modelObject.members667"
                                :items="members667ValueList"
                                dense
                                color="primary"
                                label="667 Members"
                                clearable
                                reactive
                                outlined
                                hide-details="auto"
                                :error-messages="errors?.members667"
                            />

                            <v-select tabindex="11"
                                v-model="modelObject.seminars_trainings"
                                :items="seminarsValueList"
                                dense
                                color="primary"
                                label="Seminars"
                                clearable
                                reactive
                                outlined
                                hide-details="auto"
                                :error-messages="errors?.seminars_trainings"
                            />

                            <v-select tabindex="12"
                                v-model="modelObject.committees"
                                :items="committeesValueList"
                                dense
                                color="primary"
                                label="Committees"
                                clearable
                                reactive
                                outlined
                                hide-details="auto"
                                :error-messages="errors?.committees"
                            />

                            <v-select tabindex="13"
                                v-model="modelObject.access"
                                :items="accessValueList"
                                dense
                                color="primary"
                                label="Access"
                                clearable
                                reactive
                                outlined
                                hide-details="auto"
                                :error-messages="errors?.access"
                            />

                            <v-select tabindex="14"
                                v-model="modelObject.priority"
                                :items="eventPrioritiesWithIndex"
                                item-text="text"
                                item-value="priority"
                                dense
                                color="primary"
                                label="Priority"
                                clearable
                                reactive
                                outlined
                                hide-details="auto"
                                :rules="[rules.required]"
                                :error-messages="errors?.priority"
                            />

                        </div>
                    </div>
                </v-form>

                <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                    <v-btn
                        text
                        @click="archiveModel"
                        class="main-btn"
                        :loading="archiveLoading"
                        v-show="is_edit_mode"
                    >
                        Delete
                    </v-btn>
                    <v-btn
                        text
                        @click="cancelDialog"
                        class="main-btn"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        @click="saveModel"
                        class="main-btn"
                        :loading="saveLoading"
                    >
                        Save
                    </v-btn>
                </div>
            </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker";
import WYSIWYG from "@/Generic/WYSIWYG";

export default {
    name: "EditEventModal",
    components: {
        DatePicker,
        WYSIWYG
    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'eventPrioritiesProp': {
            // The list of current event priorities (current and upcoming)
            type: Array,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: true
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
    },
    updated() {
        //
    },
    mounted() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            mode: '',
            modelObject: {},
            modelDefault: {
                id: null,
                title: null,
                image: null, // The current image if available
                new_image: null, // Custom field for new image to upload
                content: '',
                date: null,
                date_end: null,
                target: null,
                image_color: 'Normal',
                awards_festivals: null,
                outreach: null,
                // Members filters
                members667: null,
                seminars_trainings: null,
                committees: null,
                //
                priority: null,
            },
            errors: null,
            eventPriorities: this.eventPrioritiesProp || [],
            saveLoading: false,
            archiveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            activeEditor1: false,

            // Custom ValueList from model constants
            targetsValueList: [
                {text: 'Local',         value: this.constants.EVENT_TARGETS.TARGET_LOCAL},
                {text: 'International', value: this.constants.EVENT_TARGETS.TARGET_INTERNATIONAL},
            ],
            photoFiltersValueList: [
                {text: 'Normal',        value: this.constants.EVENT_PHOTO_FILTERS.PHOTO_FILTER_NORMAL},
                {text: 'Blue',          value: this.constants.EVENT_PHOTO_FILTERS.PHOTO_FILTER_BLUE},
                {text: 'Green',         value: this.constants.EVENT_PHOTO_FILTERS.PHOTO_FILTER_GREEN},
                {text: 'Black & white', value: this.constants.EVENT_PHOTO_FILTERS.PHOTO_FILTER_BLACK_AND_WHITE},
            ],
            awardsValueList: [
                {text: 'Announcements', value: this.constants.EVENT_AWARDS.AWARD_NOTICES},
                {text: 'Nominations',   value: this.constants.EVENT_AWARDS.AWARD_NOMINATIONS},
                {text: 'Winners',       value: this.constants.EVENT_AWARDS.AWARD_WINNERS},
            ],
            outreachsValueList: [
                {text: 'Events',        value: this.constants.EVENT_OUTREACHS.OUTREACH_EVENTS},
                {text: 'Workshops',     value: this.constants.EVENT_OUTREACHS.OUTREACH_WORKSHOPS},
            ],
            accessValueList: [
                {text: 'All',           value: this.constants.EVENT_ACCESS.ACCESS_ALL},
                {text: 'Public',        value: this.constants.EVENT_ACCESS.ACCESS_PUBLIC},
                {text: 'Members',       value: this.constants.EVENT_ACCESS.ACCESS_MEMBERS},
            ],
            members667ValueList: [
                {text: 'Notices',       value: this.constants.EVENT_MEMBERS667.MEMBERS667_NOTICES},
                {text: 'Memoriam',      value: this.constants.EVENT_MEMBERS667.MEMBERS667_MEMORIAM},
            ],
            seminarsValueList: [
                {text: 'Online',        value: this.constants.EVENT_SEMINAR.SEMINAR_ONLINE},
                {text: 'GTA',           value: this.constants.EVENT_SEMINAR.SEMINAR_GTA},
                {text: 'Ottawa',        value: this.constants.EVENT_SEMINAR.SEMINAR_OTTAWA},
                {text: 'Northern Ontario', value: this.constants.EVENT_SEMINAR.SEMINAR_NORTHERN_ONTARIO},
                {text: 'Atlantic',      value: this.constants.EVENT_SEMINAR.SEMINAR_ATLANTIC},
                {text: 'NFLD',          value: this.constants.EVENT_SEMINAR.SEMINAR_NFLD},
            ],
            committeesValueList: [
                {text: 'Young Workers', value: this.constants.EVENT_COMMITTEE.COMMITTEE_YOUNG_WORKERS},
                {text: 'Womens',        value: this.constants.EVENT_COMMITTEE.COMMITTEE_WOMENS},
                {text: 'Green',         value: this.constants.EVENT_COMMITTEE.COMMITTEE_GREEN},
                {text: 'Pride',         value: this.constants.EVENT_COMMITTEE.COMMITTEE_PRIDE},
                {text: 'C.O.R.E',       value: this.constants.EVENT_COMMITTEE.COMMITTEE_CORE},
                {text: 'Other',         value: this.constants.EVENT_COMMITTEE.COMMITTEE_OTHER},
            ],
        }
    },
    computed: {
        dialog_width() {
            return '80%'
        },
        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        },
        eventPrioritiesWithIndex() {
            const mappedPriorities = this.eventPriorities.map((priority, index) => ({
                ...priority,
                index: index + 1,
                text: index + 1
            }));

            if( !this.is_edit_mode ) {
                const maxPriority = mappedPriorities?.length ? Math.max(...mappedPriorities.map(priority => priority.priority)) : 1;
                const nextPriority = [{
                    priority: maxPriority + 1,
                    index: mappedPriorities.length + 1,
                    text: 'Next Priority ' + (mappedPriorities.length + 1)
                }];
                return nextPriority.concat(mappedPriorities);
            }
            return mappedPriorities;
        }
    },
    methods: {
        initEditor() {
            this.$nextTick(() => {
                this.activeEditor1 = true
            })
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            //let payload = this.modelObject
            this.modelObject.date = this.$refs.datePicker.date_temp
            this.modelObject.date_end = this.$refs.datePicker2.date_temp

            if (this.$refs.editForm.validate()) {

                let formData = new FormData()
                for (let key in this.modelObject) {
                    if (this.modelObject[key] !== null
                        && this.modelObject[key] !== undefined
                        && this.modelObject[key] !== 'undefined'
                    ) { // Adding three as system is not stable with this from time to time
                        formData.append(key, this.modelObject[key]);
                    } else {
                        formData.append(key, '');
                    }
                }

                var url = ''

                if( this.is_edit_mode ) {
                    url = route('events.update', this.modelObject.id)
                    formData.append("_method", "put")
                } else {
                    url = route('events.store')
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.eventPriorities = response.data.eventPriorities
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.$emit('successful-event-save')
                            this.modelObject.new_image = null
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknow error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error);
                    })

            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
        async archiveModel()
        {
            if (await this.$root.confirm.open(`Delete Event`, `You are about to delete ${this.modelObject.title}`)) {

                let method = 'delete'
                let url = route('events.destroy', this.modelObject.id)
                let payload = this.modelObject

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Event has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-event-delete')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {

            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.activeEditor1 = false
                this.$refs.editForm.resetValidation()
            } else {
                // Opening modal
                this.initEditor()

                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                    if (typeof this.$refs.datePicker !== 'undefined'){
                        this.$refs.datePicker.date_temp = this.modelObject.date
                    }
                    if (typeof this.$refs.datePicker2 !== 'undefined'){
                        this.$refs.datePicker2.date_temp = this.modelObject.date_end
                    }
                }
            }
        },
        'modelProp.date'(newDate) {
            if (typeof this.$refs.datePicker !== 'undefined'){
                this.$refs.datePicker.date_temp = newDate
            }
        },
        'modelProp.date_end'(newDate) {
            if (typeof this.$refs.datePicker2 !== 'undefined'){
                this.$refs.datePicker2.date_temp = newDate
            }
        },

    },
}

</script>

<style>
    .otherz {
        z-index: 1;
    }
</style>
